import useSWR, { mutate } from "swr";
import Auth from "../Auth";

const useMyVoiceStyleSamples = () => {
  const fetcher = (url) => Auth.fetchWithIdToken(url);

  const endpointURL = "/api/my_voice/style_samples";
  const {
    data: styleSamples = [],
    error,
    isLoading,
    isValidating,
    mutate: mutateSamples,
  } = useSWR(endpointURL, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
  });

  const refetchStyleSamples = async () => {
    await mutate(endpointURL);
  };

  return {
    styleSamples,
    refetchStyleSamples,
    mutateSamples,
    error,
    isLoading,
    isValidating,
  };
};

export default useMyVoiceStyleSamples;
